export const Types = {
  TOGGLE_APP_BAR: 'layout/TOGGLE_APP_BAR',
  HIDE_APP_BAR: 'layout/HIDE_APP_BAR',
  SHOW_APP_BAR: 'layout/SHOW_APP_BAR',
  TOGGLE_NAV_DRAWER: 'layout/TOGGLE_NAV_DRAWER',
  HIDE_NAV_DRAWER: 'layout/HIDE_NAV_DRAWER',
  SHOW_NAV_DRAWER: 'layout/SHOW_NAV_DRAWER',
};

const initialState = {
  isAppBarVisible: true,
  isNavDrawerVisible: false,
};

export default function layoutReducer(state = initialState, action) {
  switch (action.type) {
    case Types.TOGGLE_APP_BAR:
      return { ...state, isAppBarVisible: !state.isAppBarVisible };
    case Types.HIDE_APP_BAR:
      return { ...state, isAppBarVisible: false };
    case Types.SHOW_APP_BAR:
      return { ...state, isAppBarVisible: true };
    case Types.TOGGLE_NAV_DRAWER:
      return { ...state, isNavDrawerVisible: !state.isNavDrawerVisible };
    case Types.HIDE_NAV_DRAWER:
      return { ...state, isNavDrawerVisible: false };
    case Types.SHOW_NAV_DRAWER:
      return { ...state, isNavDrawerVisible: true };
    default:
      return state;
  }
}

export const Creators = {
  toggleAppBar: () => ({
    type: Types.TOGGLE_APP_BAR,
  }),
  hideAppBar: () => ({
    type: Types.HIDE_APP_BAR,
  }),
  showAppBar: () => ({
    type: Types.SHOW_APP_BAR,
  }),
  toggleNavDrawer: () => ({ type: Types.TOGGLE_NAV_DRAWER }),
  hideNavDrawer: () => ({ type: Types.HIDE_NAV_DRAWER }),
  showNavDrawer: () => ({ type: Types.SHOW_NAV_DRAWER }),
};
